import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    // User must update password
    if (auth.promptPassword) {
      return router.createUrlTree(['/change-password']);
    }
    return true;
  } else {
    auth.clearSession();
    return router.createUrlTree(['/login']);
  }
};
